import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import _FM_GroupCustomersComponent from "./_FM_GroupCustomersComponent";
import HelpComponent from "../HelpComponent";

const _FM_GroupShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const groupId = props.groupId ?? id;
    if (groupId) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "group/" + groupId,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [id, props.groupId, window.App.state.rerenderGroupList, window.App.state.rerenderCustomerList])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('group_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/group/')
                    setTimeout(() => {
                      navigate('/group/update/' + (props.groupId ?? id))
                    }, 500)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    if (props.onClose) {
                      props.onClose();
                    } else {
                      navigate(-1)
                    }
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('accommodation')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formData?.accommodation?.name}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="name">{t('name')}</label>
              <span className="p-d-block p-text-bold">
                {formData.name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="reservation_channel">{t('channel')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.reservation_channel?.name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="currency">{t('currency')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.currency}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="from">{t('reserved_from')}</label>
              <span className="p-d-block p-text-bold">
                    {formData.from &&
                      <>
                        {moment.utc(formData.from).local().format(t('YYYY-MM-DD'))}
                      </>
                    }
                  </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="from">{t('reserved_to')}</label>
              <span className="p-d-block p-text-bold">
                    {formData.to &&
                      <>
                        {moment.utc(formData.to).local().format(t('YYYY-MM-DD'))}
                      </>
                    }
                  </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_name">{t('contact_name')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.contact_name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_email">{t('contact_email')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.contact_email}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="contact_nationality">{t('contact_nationality')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.contact_nationality}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="company_name">{t('company_name')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.company_name}
              </span>
            </div>
          </div>
        </div>
      </Panel>
      <Panel className={"p-mt-3"}>
        <_FM_GroupCustomersComponent customers={formData?.customers} groupId={props.groupId ?? id}/>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_GroupShowComponent);
